import { createSlice } from '@reduxjs/toolkit';
import { debouncer } from '../../../../utils/debouncer';
import { createRole } from './userManagementThunks';

const initialState = {
    cards: [],
    columns: [],
    localCards: [],
    allCards: [],
    activeId: -1,
    updateColumns: 0,
    loading: false,
    searchTerm: '',
    filter: 0,
    isSelected: 0,
    createRoleOpen: false,
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    applySearch: (state) => {
      // Implement search logic here
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setColumns: (state, action) => {
      state.columns = action.payload;
    },
    setCards: (state, action) => {
        const newCards = action.payload;
        const uniqueCards = [];
        const seenCards = new Map();

        newCards.forEach(card => {
            const cardKey = Object.entries(card)
                .filter(([key]) => key !== 'id' && key !== 'avatar')
                .sort((a, b) => a[0].localeCompare(b[0]))
                .map(([key, value]) => `${key}:${value}`)
                .join(',');
            if (!seenCards.has(cardKey)) {
                seenCards.set(cardKey, true);
                uniqueCards.push(card);
            }
        });

        state.cards = uniqueCards;
    },
    setLocalCards: (state, action) => {
      state.localCards = action.payload;
    },
    setAllCards: (state, action) => {
      state.allCards = action.payload;
    },
    setActiveId: (state, action) => {
        state.activeId = action.payload;
    },
    setUpdateColumns: (state, action) => {
        state.updateColumns = action.payload;
    },
    setIsSelected: (state, action) => {
        state.isSelected = action.payload;
    },
    toggleCreateRole: (state) => {
        state.createRoleOpen = !state.createRoleOpen;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(createRole.fulfilled, (state, action) => {
        state.createRoleOpen = false;
      })

  }
});

export const {
    setSearchTerm,
    applySearch,
    setLoading,
    setColumns,
    setCards,
    setLocalCards,
    setAllCards,
    setActiveId,
    setUpdateColumns,
    setIsSelected,
    toggleCreateRole
} = userManagementSlice.actions;

export const createDebouncedSearch = (dispatch) => {
  return () => {
    debouncer.debounce('userManagement_search', () => {
      dispatch(applySearch());
    }, 300);
  };
};

export default userManagementSlice.reducer;
